import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { updateResourceAllocationAppQuery } from '../apis';
import { toast } from 'react-toastify';

const useUpdateResourceAllocation = () => {
  const mutationData = useMutation({
    mutationFn: updateResourceAllocationAppQuery,
    onSuccess: (response) => {
      const message = response?.data?.Message || 'Update resource allocation successfully';
      toast.success(message);
    },
    onError: (error) => {
      const message = error?.response?.data?.message ?? 'Server error';
      toast.error(message);
      console.error('Error Update resource allocation:', error);
    },
  });

  return mutationData;
};

export default useUpdateResourceAllocation;
